<div class="sidebar-wrapper" *transloco="let t; prefix: 'sidebar'" [class.isCollapseSidebar]="isCollapseSidebar">
  <button class="sidebar-close-button" (click)="closeSidebar?.()"><img
      src="assets/images-fuel/crossBigIcon.svg" alt=""></button>
  <nav class="navbar navbar-expand-lg navbar-light justify-content-between flex-column">
    <div class="collapse navbar-collapse align-items-start justify-content-center w-100" id="navbarNav">
      <ul class="navbar-nav flex-column w-100">
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/fuel']"
            [ngbTooltip]="isCollapseSidebar ? t('fuel.fuelDashboard') : ''" placement="right" triggers="hover">
            <div class="menuLink">
              <img src="assets/images-fuel/fuelDashboard.svg" alt=""> <span>{{ t('fuel.fuelDashboard') }}</span>
            </div>
          </a>
        </li>
        <!-- <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/atg']">
            <div class="menuLink">
              <img src="assets/images-fuel/atgDashboard.svg" alt=""> <span>ATG Dashboard</span>
            </div>
            <span class="count">2</span>
          </a>
        </li> -->
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/fuel-changes']"
            [ngbTooltip]="isCollapseSidebar ? t('fuel.fuelChanges') : ''" placement="right" triggers="hover">
            <div class="menuLink">
              <img src="assets/images-fuel/fuelChanges.svg" alt=""> <span>{{ t('fuel.fuelChanges') }}</span>
            </div>
            <!-- <span class="count">4</span> -->
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/fuel-level']"
            [ngbTooltip]="isCollapseSidebar ? t('fuel.fuelLevel') : ''" placement="right" triggers="hover">
            <div class="menuLink">
              <img src="assets/images-fuel/fuelLevel.svg" alt=""> <span>{{ t('fuel.fuelLevel') }}</span>
            </div>
            <!-- <span class="count">1</span> -->
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/fuel-consumption']"
            [ngbTooltip]="isCollapseSidebar ? t('fuel.fuelConsumption') : ''" placement="right" triggers="hover">
            <div class="menuLink">
              <img src="assets/images-fuel/fuelConsumption.svg" alt=""> <span>{{ t('fuel.fuelConsumption') }}</span>
            </div>
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/fuel-reconciliation']"
            [ngbTooltip]="isCollapseSidebar ? t('fuel.fuelReconciliation') : ''" placement="right" triggers="hover">
            <div class="menuLink">
              <img src="assets/images-fuel/fuelReconciliation.svg" alt=""> <span>{{ t('fuel.fuelReconciliation') }}</span>
            </div>
          </a>
        </li>
        <!-- <li class="nav-item" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['/fuel-management/performance']">
            <div class="menuLink">
              <img src="assets/images-fuel/performance.svg" alt="">
              <span>Performance</span>
            </div>
          </a>
        </li> -->
      </ul>
    </div>

    <button class="collapseBtn btn btn-outline-danger border-1 w-100" [class.d-none]="isCompact" (click)="btnCollapsProps()"><img
        src="assets/images-fuel/arrowLeftIcon.svg" alt="">
      {{ t('collapse') }}</button>
  </nav>
</div>